<template>
    <ValidationObserver rules="required" v-slot="{ handleSubmit }">
        <RightSideBar
            @submit="handleSubmit(editMode ? updatePayscale() : addPayScale())"
            @close="$emit('close')" submit="Save" :loading="loadingData"
            button-class="bg-dynamicBackBtn text-white"
        >
            <template v-slot:title>
                <p class="text-darkPurple">
                {{ editMode ? `Edit Pay Scale` : `New Pay Scale`}}
                </p>
            </template>
            <div>
                <div class="grid grid-cols-12 gap-2 gap-y-4 text-darkPurple" style="margin-top: 1.125rem">
                    <div class="col-span-12">
                        <TextInput placeholder="Enter" 
                            label="Pay Scale ID"
                            :rules="['required']"
                            variant="w-full" v-model="payScaleCredentials.payScaleId" 
                        />
                    </div>
                    <div class="col-span-12">
                        <p class="text-sm">
                            Job Cadre
                        </p>
                        <ComboBox :isCompensation="true" :options="jobClassificationsOpt" select @addSelectedTags="formattedJobFamilyTags($event)"
                            @removeTag="removedJobFamilyTags($event)" no-custom :exclusive-option-id="'All Job Cadre'"
                        />
                    </div>
                    <div class="col-span-12" v-if="payScaleGroupTypeForHeader === 'gradeLevel'">
                        <c-select placeholder="--Select--" :options="levelsArray" 
                            label="Grade Level" 
                            variant="w-full"
                            :rules="['required']"
                            v-model="payScaleCredentials.levelIds" 
                        />
                    </div>
                    <div class="col-span-12" v-if="payScaleGroupTypeForHeader === 'gradeLevel'">
                        <div v-for="(option, index) in currentGradeStep" :key="index"
                            class="w-full flex justify-between items-center gap-2 mb-4"
                        >
                            <c-select placeholder="--Select--" :options="jobGrades" 
                                label="Step" 
                                variant="w-full"
                                class="w-1/2"
                                :rules="['required']"
                                v-model="option.jobGradeIds" 
                            />
                            <TextInput placeholder="Enter" class="w-1/2"
                                label="Pay Scale" type="number"
                                :rules="['required']"
                                variant="w-full" v-model="option.payScaleAmount" 
                            />
                            <div @click="deleteGradeStep(index)" v-if="currentGradeStep.length > 1"
                                class="cursor-pointer h-full w-9 flex justify-center items-center mt-5"
                            >
                                <icon icon-name="trash-icon" size="s" class="icon"/>
                            </div>    
                        </div>
                        <div class="cursor-pointer mt-4"
                            @click="addAnotherStep()"
                        >
                            <p class="text-base text-flame font-bold">Add New Step</p>
                        </div>
                    </div>
                    <div class="col-span-12" v-if="payScaleGroupTypeForHeader === 'post'">
                        <p class="text-sm">
                            Post
                        </p>
                        <ComboBox :isCompensation="true" :options="allOrgDesignations" select @addSelectedTags="formattedDesignationTags($event)"
                            @removeTag="removedDesignationTags($event)" no-custom
                        />
                    </div>
                    <div class="col-span-12" v-if="payScaleGroupTypeForHeader === 'post'">
                        <TextInput placeholder="Enter" 
                            label="Pay Scale" type="number"
                            :rules="['required']"
                            variant="w-full" v-model="payScaleCredentials.payScaleAmount" 
                        />
                    </div>
                </div>
            </div>
        </RightSideBar>
    </ValidationObserver>
</template>

<script>
import * as _ from "lodash"
import VSelect from "vue-select"
import { ValidationObserver } from "vee-validate";
import "vue-select/dist/vue-select.css";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import TextInput from "@scelloo/cloudenly-ui/src/components/text";
import RightSideBar from "@/components/RightSideBar";
import ComboBox from "@/components/ComboBox";

export default {
  components: {
    CSelect,
    ComboBox,
    VSelect,
    ValidationObserver,
    TextInput,
    RightSideBar,
  },
  props: {
        payScaleCred: {
            type: Object,
            default: () => {}
        },
        editMode: {
            type: Boolean,
            default: false
        },
        payScaleGroupTypeForHeader: {
            type: String,
            default: ""
        },
        groupId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            loadingData: true,
            allOrgDesignations: [],
            jobGrades: [],
            jobClassificationsOpt: [],
            levelsArray: [],
            payScaleCredentials: {
                payScaleId: "",
                payScaleAmount: 0,
                levelIds: null,
                jobTitleId: [],
                jobClassificationId: [],
                jobGradeIds: null,
            },
            gradeStep: [
                {
                    jobGradeIds: "",
                    payScaleAmount: "",
                },
            ],
        }
    },
     computed: {
        currentGradeStep() {
            return this.gradeStep;
        }
    },
    watch:{
        'payScaleCredentials.jobClassificationId': {
            handler(newIds) {
                if (!newIds?.length) {
                    this.allOrgDesignations = [];
                    return;
                }
                this.getAllDesignations(newIds);
            },
            deep: true
        }
    },
    async mounted() {
        await this.$store.dispatch("org/getFunction");
        await this.getLevels();
        await this.getJobGrades();
        await this.getJobClassifications();
        if(this.editMode){
            this.payScaleCredentials = this.payScaleCred;
            if(this.payScaleGroupTypeForHeader === 'gradeLevel'){
                this.gradeStep = this.payScaleCredentials.jobGradeIds.map(jobGradeId => ({
                    jobGradeIds: jobGradeId,
                    payScaleAmount: this.payScaleCredentials.stepAmounts?.[jobGradeId] ?? "",
                }));
            }
            await this.getAllDesignations(this.payScaleCredentials.jobClassificationId);
            const jobClassificationId = new Set(this.payScaleCredentials.jobClassificationId);
            const jobTitleId = new Set(this.payScaleCredentials.jobTitleId);

            this.jobClassificationsOpt.forEach(item => {
                item.checked = jobClassificationId.has(item.id);
            });
            this.allOrgDesignations.forEach(item => {
                item.checked = jobTitleId.has(item.id);
            });
        }
        this.loadingData = false;
    },
    methods:{
        deleteGradeStep(index) {
            if (this.gradeStep.length > 1) {
                this.gradeStep.splice(index, 1);
            }
        },
        addAnotherStep(){
            this.gradeStep.push({
                jobGradeIds: "",
                payScaleAmount: "",
            });
        },
        handleTagSelection(selectedOption, allData, allLabel, key, callback = null) {
            if (selectedOption[0]?.id === allLabel) {
                this.payScaleCredentials[key] = allData
                    .filter(opt => opt.id !== allLabel)
                    .map(opt => opt.id);
            } else {
                this.payScaleCredentials[key] = selectedOption.map(opt => opt.id);
            }
            if (callback) {
                callback();
            }
        },
        formattedDesignationTags(selectedOption) {
            this.handleTagSelection(
                selectedOption,
                this.allOrgDesignations,
                'All Posts',
                'jobTitleId'
            );
        },
        formattedJobFamilyTags(selectedOption) {
            this.handleTagSelection(
                selectedOption,
                this.jobClassificationsOpt,
                'All Job Cadre',
                'jobClassificationId'
            );
        },
        handleRemovedTag(removedId, dataList, key, callback = null) {
            // Update checked state
            const option = dataList.find(opt => opt.id === removedId);
            if (option) {
                option.checked = false;
            }
            // Remove from credentials
            this.payScaleCredentials[key] =
                this.payScaleCredentials[key].filter(item => item !== removedId);
            // Optional callback
            if (callback) {
                callback();
            }
        },
        removedDesignationTags(removedId) {
            this.handleRemovedTag(
                removedId,
                this.allOrgDesignations,
                'jobTitleId'
            );
        },
        removedJobFamilyTags(removedId) {
            this.handleRemovedTag(
                removedId,
                this.jobClassificationsOpt,
                'jobClassificationId'
            );
        },
        async getLevels() {
            try {
                const response = await this.$_getLevels("");
                this.levelsArray = response.data.levels;
            } catch (error) {
                throw new Error(error);
            }
        },
        getJobGrades() {
            this.$_getJobGrade("").then((response) => {
                this.jobGrades = response.data.grades.map((item) => ({
                    name: item.name,
                    id: item.id,
                }));
            });
        },
        formatDropdownData(data, allLabel, filterFn = null) {
            let formattedData = data;
            if (filterFn) {
                formattedData = formattedData.filter(filterFn);
            }
            return [
                {
                    name: allLabel,
                    id: allLabel,
                    checked: false,
                    disabled: false
                },
                ...formattedData.map(({ id, name }) => ({
                    id,
                    name,
                    checked: false
                }))
            ];
        },
        async getJobClassifications() {
            const result = await this.$_getJobClassifications();
            this.jobClassificationsOpt = result.data.jobClassifications.length > 0 ? this.formatDropdownData(
                result.data.jobClassifications,
                'All Job Cadre'
            ) : []
        },
        async getAllDesignations(jobClassIds) {
            const queryParams = `functionId=&source=employees&jobClassificationId=${jobClassIds.join(',')}`;
            const result = await this.$_getCompensationDesignations(queryParams);
            const designations = result.data.jobTitles || [];
            this.allOrgDesignations = designations.length > 0
                ? [
                    ...designations
                        .map(({ id, title }) => ({
                            id,
                            name: title,
                            checked: false
                        }))
                ]
                : [];
        },
        async addPayScale(){
            this.loadingData = true;
            const { payScaleId, payScaleAmount, levelIds, jobTitleId,jobClassificationId } = this.payScaleCredentials
            const payload = {
                orgId: this.$orgId,
                groupId: this.groupId,
                jobClassificationId,
                payScaleGroupType: this.payScaleGroupTypeForHeader,
                jobTitleId,
                levelIds: levelIds ? [levelIds] : [],
                jobGradeIds: this.gradeStep.filter(item => item.jobGradeIds).map(item => item.jobGradeIds),
                stepAmounts: this.gradeStep.filter(item => item.jobGradeIds).reduce((acc, item) => {
                    acc[item.jobGradeIds] = Number(item.payScaleAmount);
                    return acc;
                }, {}),
                applyToAllJobClassification: jobClassificationId.length === this.jobClassificationsOpt.length - 1,
                payScaleId,
                ...(this.payScaleGroupTypeForHeader !== 'gradeLevel' && {
                    payScaleAmount
                })
            }
            try {
                await this.$_addPayScale(payload);
                this.loadingData = false;
                this.$emit('close');
                this.$emit('reload');
                return this.$toasted.success("Pay scale successfully added.", {duration: 6000});
            } catch (error) {
                this.loadingData = false;
                this.$toasted.error(error, {duration: 3000})
            }
        },
        async updatePayscale(){
            this.loadingData = true;
            const { groupId, id, payScaleId, payScaleAmount,
                    levelIds, jobTitleId,jobClassificationId, jobGradeIds,
            } = this.payScaleCredentials
            const payload = {
                id,
                orgId: this.$orgId,
                groupId,
                jobClassificationId,
                payScaleGroupType: this.payScaleGroupTypeForHeader,
                jobTitleId,
                levelIds: levelIds ? [levelIds] : [],
                jobGradeIds: this.gradeStep.filter(item => item.jobGradeIds).map(item => item.jobGradeIds),
                stepAmounts: this.gradeStep.filter(item => item.jobGradeIds).reduce((acc, item) => {
                    acc[item.jobGradeIds] = Number(item.payScaleAmount);
                    return acc;
                }, {}),
                applyToAllJobClassification: jobClassificationId.length === this.jobClassificationsOpt.length - 1,
                payScaleId,
                ...(this.payScaleGroupTypeForHeader !== 'gradeLevel' && {
                    payScaleAmount
                })
            }
            try {
                await this.$_updatePayScale(payload);
                this.loadingData = false;
                this.$emit('close');
                this.$emit('reload');
                return this.$toasted.success("Pay scale successfully updated.", {duration: 6000});
            } catch (error) {
                this.loadingData = false;
                this.$toasted.error(error, {duration: 3000})
            }
        }
    }
};
</script>